module.exports = __webpack_public_path__ + "static/a6f671bcdfb7e959f8c3f341548fc51dc06de2a002bc80a4217542eb927f639f-d3439c0c5c3485596b14e5d515595c58.jpeg";